// extracted by mini-css-extract-plugin
export default {"root":"UserActions_root__Y7yJd"};